import React from "react";
import { useNavigate } from "react-router-dom";

function TeamOptionsPage() {
  const navigate = useNavigate();

  const handleCreateTeam = () => {
    navigate("/create-team");
  };

  const handleJoinTeam = () => {
    navigate("/join-team");
  };

  // Centered container styling
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#f7fafc",
    padding: "1rem",
  };

  // Card styling for a modern look
  const cardStyle = {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    padding: "2rem",
    maxWidth: "500px",
    width: "100%",
    textAlign: "center",
  };

  const titleStyle = {
    fontSize: "2rem",
    fontWeight: "bold",
    color: "#1a365d",
    marginBottom: "1rem",
  };

  const subtitleStyle = {
    fontSize: "1.1rem",
    color: "#2d3748",
    marginBottom: "2rem",
  };

  // Button styling
  const buttonStyle = {
    backgroundColor: "#1a365d",
    color: "#ffffff",
    border: "none",
    borderRadius: "4px",
    padding: "0.75rem 1.5rem",
    fontSize: "1rem",
    cursor: "pointer",
    width: "100%",
    marginBottom: "1rem",
    transition: "background-color 0.2s ease-in-out",
  };

  const joinButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#ecc94b",
    color: "#1a365d",
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h2 style={titleStyle}>Team Options</h2>
        <p style={subtitleStyle}>
          Would you like to create a new team or join an existing one?
        </p>
        <button onClick={handleCreateTeam} style={buttonStyle}>
          Create a New Team
        </button>
        <button onClick={handleJoinTeam} style={joinButtonStyle}>
          Join an Existing Team
        </button>
      </div>
    </div>
  );
}

export default TeamOptionsPage;
